import styled, { css } from 'styled-components';

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  gap: 14px;
  border-radius: 4px;
  transition: background 0.15s;

  ${({ $isDraggingOver, theme }) =>
    $isDraggingOver &&
    `
      background: ${theme.borders.dashboard}33;
      outline: 1px dashed ${theme.borders.dashboard};
    `}
`;

export const GridItem = styled.div`
  flex: ${({ grow }) => grow || 1};
  min-width: 0;
  border-radius: 3px;
  border: solid 1px ${({ theme }) => theme.borders.dashboard};
  box-shadow: 0 0 20px 0 ${({ theme }) => theme.shadows.dashboard};
  background: ${({ theme }) => theme.backgrounds.dashboardWidget};
  padding: 15px 25px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({ $isEditMode }) =>
    $isEditMode &&
    css`
      padding-top: 8px;
      cursor: default;
    `}

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      opacity: 0.85;
      box-shadow: 0 8px 32px 0 ${({ theme }) => theme.shadows.dashboard};
    `}

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    `}
`;

export const EditToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  height: 24px;
`;

export const DragHandleIcon = styled.div`
  cursor: grab;
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 16px;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 3px;
  user-select: none;

  &::before {
    content: '⠿';
    letter-spacing: 2px;
  }

  &:hover {
    color: ${({ theme }) => theme.text.dashboardTitle};
    background: ${({ theme }) => theme.borders.dashboard}44;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const SettingsIconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 15px;
  padding: 2px 4px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  line-height: 1;

  &:hover {
    color: ${({ theme }) => theme.text.dashboardTitle};
    background: ${({ theme }) => theme.borders.dashboard}44;
  }
`;

export const AddWidgetRow = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 4px;
`;

export const AddWidgetButton = styled.button`
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: transparent;
  border: 1px dashed ${({ theme }) => theme.borders.dashboard};
  color: ${({ theme }) => theme.text.dashboardLightText};
  letter-spacing: 0.3px;

  &:hover {
    border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    color: ${({ theme }) => theme.borders.workspaceSelectedItem};
  }
`;
